import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { GetTenantWorkOrderFormResponse } from 'vendor-marketplace-shared-library';
import { getTenantWorkOrderForm } from '../../../services/tenant-work-order-form.service';
import ErrorPage from '../../error/ErrorPage';
import TenantWorkOrderFormComponent from './components/TenantWorkOrderFormComponent';
import Loader from '../../../components/common/Loader';
import useAlert from '../../../hooks/useAlert';

export default function TenantWorkOrderFormPage() {
  const { hash } = useParams();
  const alert = useAlert();
  const [searchParams, setSearchParams] = useSearchParams();
  const [form, setForm] = useState<GetTenantWorkOrderFormResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const getForm = async (hash: string) => {
    try {
      return await getTenantWorkOrderForm({ hash });
    } catch (err: any) {
      setLoading(false);
      alert.setAlert({ severity: 'error', message: err.message });
    }
  };

  useEffect(() => {
    if (hash) {
      getForm(hash).then(form => {
        if (form) {
          setForm(form);
        }
      });
    }
  }, [hash]);

  useEffect(() => {
    if (searchParams.get('step') === null) {
      setSearchParams({ step: '1' });
    }
  }, [searchParams]);

  useEffect(() => {
    if (form && loading) {
      setLoading(false);
    }
  }, [form]);

  if (loading) {
    return <Loader />;
  }

  if (!form || !hash || !form?.propertyAddress) {
    return (
      <ErrorPage message={'There is something wrong with the URL from your facility.'} hideButton />
    );
  }

  return (
    <Box sx={styles.mainContainer}>
      <TenantWorkOrderFormComponent propertyAddress={form.propertyAddress} hash={hash} />
    </Box>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    margin: 4,
  },
};
